<template>
  <parent>
    <loading-page v-if="fetchingExternalAccounts" />

    <div v-else>
      <b-button
        variant="bg-primary"
        class=""
        @click="addExternalAccount()"
      >
        <GjIcon
          class="icon-left"
          name="Plus"
        />
        Add External Account
      </b-button>

      <div class="pt-1">
        <template v-if="externalAccounts.length === 0">
          <no-data
            no-data-text="No external account have been added yet..."
            icon="UploadCloud"
            create-text="+ Add External Account"
            access-page="Behaviors"
            class="text-center mt-5 pt-5"
            @action="addExternalAccount()"
          />
        </template>

        <ul
          v-for="(externalAccount, property) in externalAccounts"
          :key="property"
          class="ml-0 pl-0"
        >
          <paper-simple class="mt-2">
            <div class="d-flex align-items-center justify-content-between">
              <div class="d-flex align-items-center">
                <img
                  width="40px"
                  height="40px"
                  alt="Account image"
                  :src="externalAccount.providerImageUrl"
                >
                <h6 class="ml-2 mb-0 mr-5">
                  {{ externalAccount.username }}
                </h6>
              </div>
              <div class="mr-auto">
                {{ externalAccount.label }}
              </div>

              <div>
                <b-dropdown
                  size="lg"
                  variant="link"
                  toggle-class="text-decoration-none"
                  no-caret
                  dropleft
                >
                  <template #button-content>
                    <GjIcon name="Moreoptions" />
                  </template>
                  <b-dropdown-item
                    @click="
                      $router.push({
                        name: 'edit-external-account',
                        params: { id: externalAccount.id },
                      })
                    "
                  >
                    <GjIcon name="Edit" />
                    Edit
                  </b-dropdown-item>
                  <b-dropdown-item
                    @click="deleteAccount(externalAccount.id, externalAccount.providerName)"
                  >
                    <GjIcon name="Delete" />
                    Delete
                  </b-dropdown-item>
                </b-dropdown>
              </div>
            </div>
          </paper-simple>
        </ul>
      </div>
    </div>
  </parent>
</template>

<script>
export default {
  name: 'ExternalAccounts',
  computed: {
    externalAccounts() {
      return this.$store.state.externalAccount.externalAccountNoCaptain
    },
    fetchingExternalAccounts() {
      return this.$store.state.externalAccount.fetchingExternalAccounts
    },
  },
  created() {
    this.fetchAccounts()
  },
  methods: {
    addExternalAccount() {
      this.$router.push({ name: 'add-external-account' })
    },
    fetchAccounts() {
      this.$store
        .dispatch('externalAccount/fetchAccounts')
        .catch(error => {
          const { status } = error?.response || null
          if (status === 424) {
            this.$store.commit('accountBuckets/SET_SHOW_INTRO', true)
            this.$store.commit('buckets/SET_SHOW_INTRO', true)
            return
          }
          if (status === 426 || status === 428) {
            this.$store.commit('accountBuckets/SET_SERVICE_UNAVAILABLE', status === 428)
            this.$store.commit('buckets/SET_SERVICE_UNAVAILABLE', status === 428)
            return
          }
          this.errorToast(
            error.response?.data?.errors
              || 'Something went wrong while fetching all external accounts.',
          )
        })
    },
    deleteAccount(id, providerName) {
      this.confirmDelete(
        `Delete ${providerName} external account`,
        `Are you sure you want to delete ${providerName} external account?`,
      ).then(ok => {
        if (ok) {
          this.$store
            .dispatch('externalAccount/deleteAccount', id)
            .then(() => {
              this.successToast('External account is deleted')
              this.fetchAccounts()
            })
            .catch(error => {
              this.errorToast(
                error.response?.data?.errors[0]
                  || 'Something went wrong while deleting external account.',
              )
            })
        }
      })
    },
    editExternalAccount(id) {
      this.$store.dispatch('externalAccount/fetchAccount', id)
      this.$router
        .push({
          name: 'edit-external-account',
          params: { id },
        })
        .catch(err => {
          this.errorToast(
            err.response?.data?.errors[0]
                  || 'Something went wrong while updating external account.',
          )
        })
    },
  },
}
</script>
